var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExportExcelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_424_361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.92138 0.691667C9.79313 0.585917 9.62325 0.542042 9.459 0.572417L0.459 2.25992C0.192375 2.30942 0 2.54117 0 2.81229V15.1873C0 15.4573 0.192375 15.6902 0.459 15.7397L9.459 17.4272C9.49275 17.4339 9.52875 17.4373 9.5625 17.4373C9.69188 17.4373 9.82013 17.3923 9.92138 17.3079C10.0508 17.201 10.125 17.0413 10.125 16.8748V1.12479C10.125 0.957167 10.0508 0.798542 9.92138 0.691667ZM9 16.1964L1.125 14.7204V3.27917L9 1.80317V16.1964Z",
    fill: "#CC5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 2.81201H9.5625C9.252 2.81201 9 3.06401 9 3.37451C9 3.68501 9.252 3.93701 9.5625 3.93701H16.875V14.062H9.5625C9.252 14.062 9 14.314 9 14.6245C9 14.935 9.252 15.187 9.5625 15.187H17.4375C17.748 15.187 18 14.935 18 14.6245V3.37451C18 3.06401 17.748 2.81201 17.4375 2.81201Z",
    fill: "#CC5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 5.06201H9.5625C9.252 5.06201 9 5.31401 9 5.62451C9 5.93501 9.252 6.18701 9.5625 6.18701H11.8125C12.123 6.18701 12.375 5.93501 12.375 5.62451C12.375 5.31401 12.123 5.06201 11.8125 5.06201Z",
    fill: "#CC5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 7.31201H9.5625C9.252 7.31201 9 7.56401 9 7.87451C9 8.18501 9.252 8.43701 9.5625 8.43701H11.8125C12.123 8.43701 12.375 8.18501 12.375 7.87451C12.375 7.56401 12.123 7.31201 11.8125 7.31201Z",
    fill: "#CC5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 9.56201H9.5625C9.252 9.56201 9 9.81401 9 10.1245C9 10.435 9.252 10.687 9.5625 10.687H11.8125C12.123 10.687 12.375 10.435 12.375 10.1245C12.375 9.81401 12.123 9.56201 11.8125 9.56201Z",
    fill: "#CC5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 11.812H9.5625C9.252 11.812 9 12.064 9 12.3745C9 12.685 9.252 12.937 9.5625 12.937H11.8125C12.123 12.937 12.375 12.685 12.375 12.3745C12.375 12.064 12.123 11.812 11.8125 11.812Z",
    fill: "#CC5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 5.06201H14.0625C13.752 5.06201 13.5 5.31401 13.5 5.62451C13.5 5.93501 13.752 6.18701 14.0625 6.18701H15.1875C15.498 6.18701 15.75 5.93501 15.75 5.62451C15.75 5.31401 15.498 5.06201 15.1875 5.06201Z",
    fill: "#CC5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 7.31201H14.0625C13.752 7.31201 13.5 7.56401 13.5 7.87451C13.5 8.18501 13.752 8.43701 14.0625 8.43701H15.1875C15.498 8.43701 15.75 8.18501 15.75 7.87451C15.75 7.56401 15.498 7.31201 15.1875 7.31201Z",
    fill: "#CC5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 9.56201H14.0625C13.752 9.56201 13.5 9.81401 13.5 10.1245C13.5 10.435 13.752 10.687 14.0625 10.687H15.1875C15.498 10.687 15.75 10.435 15.75 10.1245C15.75 9.81401 15.498 9.56201 15.1875 9.56201Z",
    fill: "#CC5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 11.812H14.0625C13.752 11.812 13.5 12.064 13.5 12.3745C13.5 12.685 13.752 12.937 14.0625 12.937H15.1875C15.498 12.937 15.75 12.685 15.75 12.3745C15.75 12.064 15.498 11.812 15.1875 11.812Z",
    fill: "#CC5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73647 10.8796L3.79897 6.37961C3.59197 6.14449 3.23759 6.12199 3.00472 6.32674C2.77072 6.53149 2.74709 6.88699 2.95184 7.11986L6.88934 11.6199C7.00072 11.747 7.15597 11.8122 7.31234 11.8122C7.44397 11.8122 7.57559 11.7661 7.68359 11.6727C7.91759 11.468 7.94122 11.1136 7.73647 10.8796Z",
    fill: "#CC5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65789 5.74369C7.41264 5.55132 7.05939 5.59744 6.86814 5.84157L2.93064 10.9041C2.74052 11.1493 2.78439 11.5037 3.02964 11.6938C3.13314 11.7737 3.25464 11.8119 3.37502 11.8119C3.54152 11.8119 3.70802 11.7377 3.81827 11.5959L7.75577 6.53344C7.94702 6.28707 7.90314 5.93382 7.65789 5.74369Z",
    fill: "#CC5A5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_424_361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportExcelIcon);
export default __webpack_public_path__ + "static/media/export-excel-icon.55d63b23be46eb952f2984e1dfab6268.svg";
export { ForwardRef as ReactComponent };